import React, {useEffect, useRef, useState, useId} from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PlayDisabledIcon from '@mui/icons-material/PlayDisabled';
import Pause from '@mui/icons-material/Pause';
import Fab from '@mui/material/Fab';

export default function MediaPlayer(props) {
    const {media, play, mediaType} = props;
    const mediaPlayer = useRef(null);
    const [mediaPlayerState, setMediaPlayerState] = useState(null);
    const mediaId = useId()

    const mediaPlay = () => {
        if(mediaPlayer.current) {
            if(mediaPlayer.current.paused) {
                mediaPlayer.current.play();
                setMediaPlayerState('play');
            }
        }
    }

    const mediaPause = () => {
        if(mediaPlayer.current) {
            if(!mediaPlayer.current.paused) {
                mediaPlayer.current.pause();
                setMediaPlayerState('paused');
            } 
        }
    }

    const mediaTogglePlay = () => {
        if(mediaPlayer.current) {
            if(!mediaPlayer.current.paused) {
                mediaPlayer.current.pause();
                setMediaPlayerState('paused');
            } else {
                mediaPlayer.current.play();
                setMediaPlayerState('play');
            }
        }
    }

    useEffect(() => {
        if (play) {
            mediaPlay();
        } else {
            mediaPause();
        }
    }, [play]);


    useEffect(() => {
        
        const onPlayerEnd = () => { 
            
            if(mediaPlayer.current) {
                mediaPlayer.current.addEventListener('ended', function() {
                    setMediaPlayerState('paused');
                });
            }
        }

        onPlayerEnd();

    },[setMediaPlayerState, mediaId]);
console.log(props)
    return(
        <>
        {media && 
                <>
                    <video 
                        id={mediaId}
                        ref={mediaPlayer}
                        src={media.src}
                        width={props.width}
                        style={props.style}
                        controls={props.controls}
                        playsInline
                        autoPlay={props.autoPlay}
                        loop={true}
                        loading={props.loading} />
                        {!media.hideControls &&
                        <Fab sx={{position:"absolute",top:"8px",right:"48px",height:"36px",width:"36px",boxShadow:"unset"}} size="small" color="default" onClick={mediaTogglePlay}>
                            {mediaPlayerState === "paused" ?
                                <PlayArrowIcon fontSize="small" /> 
                            : mediaType === "video" ? 
                                <Pause fontSize="small" />
                                : 
                                <PlayDisabledIcon fontSize="small" />
                            }
                        </Fab>}
                </>
            }
        </>
    );
}
